export default {
    getCategorias: state => {
        return state.categorias;
    },

    getNomeCategoriaById: state => (categoriaId) => {
        const realizaBuscaDeCategoria = function(categorias, id){
            return categorias?.find(c =>
                c.id === id ||
                c.subcategorias?.some(sc => sc.id === id) ||
                realizaBuscaDeCategoria(c.subcategorias, id)
            );
        }

        return realizaBuscaDeCategoria(state.categorias, categoriaId)?.nome || "";
    }
}